// BPMN Template XMLs for different categories
export const bpmnTemplates = {
    // Marketing - Email Campaign template
    emailCampaign: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="email-campaign" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="EmailCampaign" name="Email Campaign" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="Campaign Start"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:userTask id="CreateContent" name="Create Email Content"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:serviceTask id="SendEmails" name="Send Emails"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:userTask id="TrackMetrics" name="Track Metrics"><bpmn2:incoming>Flow3</bpmn2:incoming><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:endEvent id="End" name="Campaign Complete"><bpmn2:incoming>Flow4</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="CreateContent"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="CreateContent" targetRef="SendEmails"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="SendEmails" targetRef="TrackMetrics"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="TrackMetrics" targetRef="End"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="EmailCampaign">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="102" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="CreateContent_di" bpmnElement="CreateContent"><dc:Bounds x="240" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="SendEmails_di" bpmnElement="SendEmails"><dc:Bounds x="390" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="TrackMetrics_di" bpmnElement="TrackMetrics"><dc:Bounds x="540" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="End_di" bpmnElement="End"><dc:Bounds x="692" y="102" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="120"/><di:waypoint x="240" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="120"/><di:waypoint x="390" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="490" y="120"/><di:waypoint x="540" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="640" y="120"/><di:waypoint x="692" y="120"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,

    // Sales - Lead Qualification
    leadQualification: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="lead-qualification" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="LeadQualification" name="Lead Qualification" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="New Lead"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:userTask id="ReviewLead" name="Review Lead Info"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:exclusiveGateway id="Gateway" name="Qualified?"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>FlowYes</bpmn2:outgoing><bpmn2:outgoing>FlowNo</bpmn2:outgoing></bpmn2:exclusiveGateway>
    <bpmn2:userTask id="AssignRep" name="Assign Sales Rep"><bpmn2:incoming>FlowYes</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:serviceTask id="SendRejection" name="Send Rejection Email"><bpmn2:incoming>FlowNo</bpmn2:incoming><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:endEvent id="EndQualified" name="Qualified"><bpmn2:incoming>Flow3</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:endEvent id="EndRejected" name="Rejected"><bpmn2:incoming>Flow4</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="ReviewLead"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="ReviewLead" targetRef="Gateway"/>
    <bpmn2:sequenceFlow id="FlowYes" name="Yes" sourceRef="Gateway" targetRef="AssignRep"/>
    <bpmn2:sequenceFlow id="FlowNo" name="No" sourceRef="Gateway" targetRef="SendRejection"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="AssignRep" targetRef="EndQualified"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="SendRejection" targetRef="EndRejected"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="LeadQualification">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ReviewLead_di" bpmnElement="ReviewLead"><dc:Bounds x="240" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="Gateway_di" bpmnElement="Gateway" isMarkerVisible="true"><dc:Bounds x="395" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="AssignRep_di" bpmnElement="AssignRep"><dc:Bounds x="500" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="SendRejection_di" bpmnElement="SendRejection"><dc:Bounds x="500" y="200" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="EndQualified_di" bpmnElement="EndQualified"><dc:Bounds x="652" y="102" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="EndRejected_di" bpmnElement="EndRejected"><dc:Bounds x="652" y="222" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="170"/><di:waypoint x="240" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="170"/><di:waypoint x="395" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowYes_di" bpmnElement="FlowYes"><di:waypoint x="420" y="145"/><di:waypoint x="420" y="120"/><di:waypoint x="500" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowNo_di" bpmnElement="FlowNo"><di:waypoint x="420" y="195"/><di:waypoint x="420" y="240"/><di:waypoint x="500" y="240"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="600" y="120"/><di:waypoint x="652" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="600" y="240"/><di:waypoint x="652" y="240"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,

    // HR - Employee Onboarding
    employeeOnboarding: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="employee-onboarding" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="EmployeeOnboarding" name="Employee Onboarding" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="New Hire"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:userTask id="PrepareDocuments" name="Prepare Documents"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:parallelGateway id="ParallelStart"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:parallelGateway>
    <bpmn2:serviceTask id="SetupEmail" name="Setup Email Account"><bpmn2:incoming>Flow3</bpmn2:incoming><bpmn2:outgoing>Flow5</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:userTask id="AssignEquipment" name="Assign Equipment"><bpmn2:incoming>Flow4</bpmn2:incoming><bpmn2:outgoing>Flow6</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:parallelGateway id="ParallelEnd"><bpmn2:incoming>Flow5</bpmn2:incoming><bpmn2:incoming>Flow6</bpmn2:incoming><bpmn2:outgoing>Flow7</bpmn2:outgoing></bpmn2:parallelGateway>
    <bpmn2:userTask id="Orientation" name="Conduct Orientation"><bpmn2:incoming>Flow7</bpmn2:incoming><bpmn2:outgoing>Flow8</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:endEvent id="End" name="Onboarded"><bpmn2:incoming>Flow8</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="PrepareDocuments"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="PrepareDocuments" targetRef="ParallelStart"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="ParallelStart" targetRef="SetupEmail"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="ParallelStart" targetRef="AssignEquipment"/>
    <bpmn2:sequenceFlow id="Flow5" sourceRef="SetupEmail" targetRef="ParallelEnd"/>
    <bpmn2:sequenceFlow id="Flow6" sourceRef="AssignEquipment" targetRef="ParallelEnd"/>
    <bpmn2:sequenceFlow id="Flow7" sourceRef="ParallelEnd" targetRef="Orientation"/>
    <bpmn2:sequenceFlow id="Flow8" sourceRef="Orientation" targetRef="End"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="EmployeeOnboarding">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="PrepareDocuments_di" bpmnElement="PrepareDocuments"><dc:Bounds x="240" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ParallelStart_di" bpmnElement="ParallelStart"><dc:Bounds x="395" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="SetupEmail_di" bpmnElement="SetupEmail"><dc:Bounds x="500" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="AssignEquipment_di" bpmnElement="AssignEquipment"><dc:Bounds x="500" y="200" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ParallelEnd_di" bpmnElement="ParallelEnd"><dc:Bounds x="655" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="Orientation_di" bpmnElement="Orientation"><dc:Bounds x="760" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="End_di" bpmnElement="End"><dc:Bounds x="912" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="170"/><di:waypoint x="240" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="170"/><di:waypoint x="395" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="420" y="145"/><di:waypoint x="420" y="120"/><di:waypoint x="500" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="420" y="195"/><di:waypoint x="420" y="240"/><di:waypoint x="500" y="240"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow5_di" bpmnElement="Flow5"><di:waypoint x="600" y="120"/><di:waypoint x="680" y="120"/><di:waypoint x="680" y="145"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow6_di" bpmnElement="Flow6"><di:waypoint x="600" y="240"/><di:waypoint x="680" y="240"/><di:waypoint x="680" y="195"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow7_di" bpmnElement="Flow7"><di:waypoint x="705" y="170"/><di:waypoint x="760" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow8_di" bpmnElement="Flow8"><di:waypoint x="860" y="170"/><di:waypoint x="912" y="170"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,

    // Finance - Invoice Approval
    invoiceApproval: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="invoice-approval" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="InvoiceApproval" name="Invoice Approval" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="Invoice Received"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:userTask id="ReviewInvoice" name="Review Invoice"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:exclusiveGateway id="AmountGateway" name="Amount > $5000?"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>FlowHigh</bpmn2:outgoing><bpmn2:outgoing>FlowLow</bpmn2:outgoing></bpmn2:exclusiveGateway>
    <bpmn2:userTask id="ManagerApproval" name="Manager Approval"><bpmn2:incoming>FlowHigh</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:serviceTask id="AutoApprove" name="Auto Approve"><bpmn2:incoming>FlowLow</bpmn2:incoming><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:exclusiveGateway id="MergeGateway"><bpmn2:incoming>Flow3</bpmn2:incoming><bpmn2:incoming>Flow4</bpmn2:incoming><bpmn2:outgoing>Flow5</bpmn2:outgoing></bpmn2:exclusiveGateway>
    <bpmn2:serviceTask id="ProcessPayment" name="Process Payment"><bpmn2:incoming>Flow5</bpmn2:incoming><bpmn2:outgoing>Flow6</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:endEvent id="End" name="Payment Complete"><bpmn2:incoming>Flow6</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="ReviewInvoice"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="ReviewInvoice" targetRef="AmountGateway"/>
    <bpmn2:sequenceFlow id="FlowHigh" name="Yes" sourceRef="AmountGateway" targetRef="ManagerApproval"/>
    <bpmn2:sequenceFlow id="FlowLow" name="No" sourceRef="AmountGateway" targetRef="AutoApprove"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="ManagerApproval" targetRef="MergeGateway"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="AutoApprove" targetRef="MergeGateway"/>
    <bpmn2:sequenceFlow id="Flow5" sourceRef="MergeGateway" targetRef="ProcessPayment"/>
    <bpmn2:sequenceFlow id="Flow6" sourceRef="ProcessPayment" targetRef="End"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="InvoiceApproval">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ReviewInvoice_di" bpmnElement="ReviewInvoice"><dc:Bounds x="240" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="AmountGateway_di" bpmnElement="AmountGateway" isMarkerVisible="true"><dc:Bounds x="395" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ManagerApproval_di" bpmnElement="ManagerApproval"><dc:Bounds x="500" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="AutoApprove_di" bpmnElement="AutoApprove"><dc:Bounds x="500" y="200" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="MergeGateway_di" bpmnElement="MergeGateway" isMarkerVisible="true"><dc:Bounds x="655" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ProcessPayment_di" bpmnElement="ProcessPayment"><dc:Bounds x="760" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="End_di" bpmnElement="End"><dc:Bounds x="912" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="170"/><di:waypoint x="240" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="170"/><di:waypoint x="395" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowHigh_di" bpmnElement="FlowHigh"><di:waypoint x="420" y="145"/><di:waypoint x="420" y="120"/><di:waypoint x="500" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowLow_di" bpmnElement="FlowLow"><di:waypoint x="420" y="195"/><di:waypoint x="420" y="240"/><di:waypoint x="500" y="240"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="600" y="120"/><di:waypoint x="680" y="120"/><di:waypoint x="680" y="145"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="600" y="240"/><di:waypoint x="680" y="240"/><di:waypoint x="680" y="195"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow5_di" bpmnElement="Flow5"><di:waypoint x="705" y="170"/><di:waypoint x="760" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow6_di" bpmnElement="Flow6"><di:waypoint x="860" y="170"/><di:waypoint x="912" y="170"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,

    // IT - Incident Management
    incidentManagement: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="incident-management" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="IncidentManagement" name="Incident Management" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="Incident Reported"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:userTask id="Triage" name="Triage Incident"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:exclusiveGateway id="PriorityGateway" name="Priority?"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>FlowCritical</bpmn2:outgoing><bpmn2:outgoing>FlowNormal</bpmn2:outgoing></bpmn2:exclusiveGateway>
    <bpmn2:userTask id="EscalateTeam" name="Escalate to Team Lead"><bpmn2:incoming>FlowCritical</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:userTask id="AssignTechnician" name="Assign Technician"><bpmn2:incoming>FlowNormal</bpmn2:incoming><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:exclusiveGateway id="MergeGateway"><bpmn2:incoming>Flow3</bpmn2:incoming><bpmn2:incoming>Flow4</bpmn2:incoming><bpmn2:outgoing>Flow5</bpmn2:outgoing></bpmn2:exclusiveGateway>
    <bpmn2:userTask id="ResolveIncident" name="Resolve Incident"><bpmn2:incoming>Flow5</bpmn2:incoming><bpmn2:outgoing>Flow6</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:serviceTask id="SendNotification" name="Send Resolution Notification"><bpmn2:incoming>Flow6</bpmn2:incoming><bpmn2:outgoing>Flow7</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:endEvent id="End" name="Incident Closed"><bpmn2:incoming>Flow7</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="Triage"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="Triage" targetRef="PriorityGateway"/>
    <bpmn2:sequenceFlow id="FlowCritical" name="Critical" sourceRef="PriorityGateway" targetRef="EscalateTeam"/>
    <bpmn2:sequenceFlow id="FlowNormal" name="Normal" sourceRef="PriorityGateway" targetRef="AssignTechnician"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="EscalateTeam" targetRef="MergeGateway"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="AssignTechnician" targetRef="MergeGateway"/>
    <bpmn2:sequenceFlow id="Flow5" sourceRef="MergeGateway" targetRef="ResolveIncident"/>
    <bpmn2:sequenceFlow id="Flow6" sourceRef="ResolveIncident" targetRef="SendNotification"/>
    <bpmn2:sequenceFlow id="Flow7" sourceRef="SendNotification" targetRef="End"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="IncidentManagement">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="Triage_di" bpmnElement="Triage"><dc:Bounds x="240" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="PriorityGateway_di" bpmnElement="PriorityGateway" isMarkerVisible="true"><dc:Bounds x="395" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="EscalateTeam_di" bpmnElement="EscalateTeam"><dc:Bounds x="500" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="AssignTechnician_di" bpmnElement="AssignTechnician"><dc:Bounds x="500" y="200" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="MergeGateway_di" bpmnElement="MergeGateway" isMarkerVisible="true"><dc:Bounds x="655" y="145" width="50" height="50"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ResolveIncident_di" bpmnElement="ResolveIncident"><dc:Bounds x="760" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="SendNotification_di" bpmnElement="SendNotification"><dc:Bounds x="910" y="130" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="End_di" bpmnElement="End"><dc:Bounds x="1062" y="152" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="170"/><di:waypoint x="240" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="170"/><di:waypoint x="395" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowCritical_di" bpmnElement="FlowCritical"><di:waypoint x="420" y="145"/><di:waypoint x="420" y="120"/><di:waypoint x="500" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="FlowNormal_di" bpmnElement="FlowNormal"><di:waypoint x="420" y="195"/><di:waypoint x="420" y="240"/><di:waypoint x="500" y="240"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="600" y="120"/><di:waypoint x="680" y="120"/><di:waypoint x="680" y="145"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="600" y="240"/><di:waypoint x="680" y="240"/><di:waypoint x="680" y="195"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow5_di" bpmnElement="Flow5"><di:waypoint x="705" y="170"/><di:waypoint x="760" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow6_di" bpmnElement="Flow6"><di:waypoint x="860" y="170"/><di:waypoint x="910" y="170"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow7_di" bpmnElement="Flow7"><di:waypoint x="1010" y="170"/><di:waypoint x="1062" y="170"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,

    // Payroll Processing
    payrollProcessing: `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="payroll-processing" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn2:process id="PayrollProcessing" name="Payroll Processing" isExecutable="true" camunda:historyTimeToLive="2">
    <bpmn2:startEvent id="Start" name="Payroll Period Start"><bpmn2:outgoing>Flow1</bpmn2:outgoing></bpmn2:startEvent>
    <bpmn2:serviceTask id="CollectTimesheet" name="Collect Timesheets"><bpmn2:incoming>Flow1</bpmn2:incoming><bpmn2:outgoing>Flow2</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:serviceTask id="CalculateSalary" name="Calculate Salaries"><bpmn2:incoming>Flow2</bpmn2:incoming><bpmn2:outgoing>Flow3</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:userTask id="ReviewPayroll" name="Review Payroll"><bpmn2:incoming>Flow3</bpmn2:incoming><bpmn2:outgoing>Flow4</bpmn2:outgoing></bpmn2:userTask>
    <bpmn2:serviceTask id="ProcessPayment" name="Process Payments"><bpmn2:incoming>Flow4</bpmn2:incoming><bpmn2:outgoing>Flow5</bpmn2:outgoing></bpmn2:serviceTask>
    <bpmn2:endEvent id="End" name="Payroll Complete"><bpmn2:incoming>Flow5</bpmn2:incoming></bpmn2:endEvent>
    <bpmn2:sequenceFlow id="Flow1" sourceRef="Start" targetRef="CollectTimesheet"/>
    <bpmn2:sequenceFlow id="Flow2" sourceRef="CollectTimesheet" targetRef="CalculateSalary"/>
    <bpmn2:sequenceFlow id="Flow3" sourceRef="CalculateSalary" targetRef="ReviewPayroll"/>
    <bpmn2:sequenceFlow id="Flow4" sourceRef="ReviewPayroll" targetRef="ProcessPayment"/>
    <bpmn2:sequenceFlow id="Flow5" sourceRef="ProcessPayment" targetRef="End"/>
  </bpmn2:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="PayrollProcessing">
    <bpmndi:BPMNShape id="Start_di" bpmnElement="Start"><dc:Bounds x="152" y="102" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="CollectTimesheet_di" bpmnElement="CollectTimesheet"><dc:Bounds x="240" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="CalculateSalary_di" bpmnElement="CalculateSalary"><dc:Bounds x="390" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ReviewPayroll_di" bpmnElement="ReviewPayroll"><dc:Bounds x="540" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="ProcessPayment_di" bpmnElement="ProcessPayment"><dc:Bounds x="690" y="80" width="100" height="80"/></bpmndi:BPMNShape>
    <bpmndi:BPMNShape id="End_di" bpmnElement="End"><dc:Bounds x="842" y="102" width="36" height="36"/></bpmndi:BPMNShape>
    <bpmndi:BPMNEdge id="Flow1_di" bpmnElement="Flow1"><di:waypoint x="188" y="120"/><di:waypoint x="240" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow2_di" bpmnElement="Flow2"><di:waypoint x="340" y="120"/><di:waypoint x="390" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow3_di" bpmnElement="Flow3"><di:waypoint x="490" y="120"/><di:waypoint x="540" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow4_di" bpmnElement="Flow4"><di:waypoint x="640" y="120"/><di:waypoint x="690" y="120"/></bpmndi:BPMNEdge>
    <bpmndi:BPMNEdge id="Flow5_di" bpmnElement="Flow5"><di:waypoint x="790" y="120"/><di:waypoint x="842" y="120"/></bpmndi:BPMNEdge>
  </bpmndi:BPMNPlane></bpmndi:BPMNDiagram>
</bpmn2:definitions>`,
};

// Template data with categories
export interface WorkflowTemplate {
    id: string;
    title: string;
    description: string;
    category: 'Marketing' | 'Sales' | 'HR' | 'Finance' | 'IT';
    popular: boolean;
    icons: { color: string; letter?: string; icon?: string }[];
    gradient: string;
    bpmnTemplate: string;
}

export const templates: WorkflowTemplate[] = [
    // Marketing Templates
    {
        id: 'marketing-1',
        title: 'Email Campaign Automation',
        description: 'Automate your email marketing campaigns with content creation, sending, and metrics tracking.',
        category: 'Marketing',
        popular: true,
        icons: [{ color: 'bg-blue-500', letter: '📧' }, { color: 'bg-orange-500', icon: '📊' }],
        gradient: 'from-cyan-400 to-blue-500',
        bpmnTemplate: bpmnTemplates.emailCampaign,
    },
    {
        id: 'marketing-2',
        title: 'Social Media Scheduler',
        description: 'Schedule and publish content across multiple social media platforms automatically.',
        category: 'Marketing',
        popular: false,
        icons: [{ color: 'bg-pink-500', letter: '📱' }, { color: 'bg-purple-500', icon: '🗓️' }],
        gradient: 'from-pink-400 to-purple-500',
        bpmnTemplate: bpmnTemplates.emailCampaign,
    },
    {
        id: 'marketing-3',
        title: 'Content Approval Workflow',
        description: 'Streamline content review and approval process with automated routing and notifications.',
        category: 'Marketing',
        popular: true,
        icons: [{ color: 'bg-indigo-500', letter: '✅' }, { color: 'bg-blue-500', icon: '📝' }],
        gradient: 'from-indigo-400 to-blue-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },

    // Sales Templates
    {
        id: 'sales-1',
        title: 'Lead Qualification',
        description: 'Automatically qualify and route leads to the right sales representatives based on criteria.',
        category: 'Sales',
        popular: true,
        icons: [{ color: 'bg-green-500', letter: '🎯' }, { color: 'bg-teal-500', icon: '👤' }],
        gradient: 'from-green-400 to-teal-500',
        bpmnTemplate: bpmnTemplates.leadQualification,
    },
    {
        id: 'sales-2',
        title: 'Quote Approval Process',
        description: 'Automate quote creation, review, and approval with built-in pricing rules.',
        category: 'Sales',
        popular: false,
        icons: [{ color: 'bg-amber-500', letter: '💰' }, { color: 'bg-orange-500', icon: '📋' }],
        gradient: 'from-amber-400 to-orange-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },
    {
        id: 'sales-3',
        title: 'Contract Management',
        description: 'Manage contract lifecycle from creation to signature with automated reminders.',
        category: 'Sales',
        popular: true,
        icons: [{ color: 'bg-blue-500', letter: '📄' }, { color: 'bg-indigo-500', icon: '✍️' }],
        gradient: 'from-blue-400 to-indigo-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },

    // HR Templates
    {
        id: 'hr-1',
        title: 'Employee Onboarding',
        description: 'Streamline new employee onboarding with automated document preparation and IT setup.',
        category: 'HR',
        popular: true,
        icons: [{ color: 'bg-teal-500', icon: '👋' }, { color: 'bg-cyan-500', letter: '📋' }],
        gradient: 'from-teal-400 to-cyan-500',
        bpmnTemplate: bpmnTemplates.employeeOnboarding,
    },
    {
        id: 'hr-2',
        title: 'Leave Request Approval',
        description: 'Automate leave requests with manager approval and calendar integration.',
        category: 'HR',
        popular: true,
        icons: [{ color: 'bg-purple-500', letter: '🏖️' }, { color: 'bg-pink-500', icon: '✅' }],
        gradient: 'from-purple-400 to-pink-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },
    {
        id: 'hr-3',
        title: 'Performance Review Cycle',
        description: 'Manage annual performance reviews with automated scheduling and feedback collection.',
        category: 'HR',
        popular: false,
        icons: [{ color: 'bg-amber-500', letter: '⭐' }, { color: 'bg-yellow-500', icon: '📊' }],
        gradient: 'from-amber-400 to-yellow-500',
        bpmnTemplate: bpmnTemplates.employeeOnboarding,
    },

    // Finance Templates
    {
        id: 'finance-1',
        title: 'Invoice Approval',
        description: 'Automate invoice review and approval with amount-based routing and payment processing.',
        category: 'Finance',
        popular: true,
        icons: [{ color: 'bg-emerald-500', letter: '💳' }, { color: 'bg-green-500', icon: '✅' }],
        gradient: 'from-emerald-400 to-green-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },
    {
        id: 'finance-2',
        title: 'Payroll Processing',
        description: 'Automate payroll with timesheet collection, salary calculation, and payment processing.',
        category: 'Finance',
        popular: true,
        icons: [{ color: 'bg-blue-500', letter: '💵' }, { color: 'bg-purple-500', icon: '📅' }],
        gradient: 'from-blue-400 to-purple-500',
        bpmnTemplate: bpmnTemplates.payrollProcessing,
    },
    {
        id: 'finance-3',
        title: 'Expense Reimbursement',
        description: 'Submit and approve expense claims with receipt verification and reimbursement tracking.',
        category: 'Finance',
        popular: false,
        icons: [{ color: 'bg-orange-500', letter: '🧾' }, { color: 'bg-red-500', icon: '💰' }],
        gradient: 'from-orange-400 to-red-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },

    // IT Templates
    {
        id: 'it-1',
        title: 'Incident Management',
        description: 'Triage and resolve IT incidents with priority-based escalation and notifications.',
        category: 'IT',
        popular: true,
        icons: [{ color: 'bg-red-500', letter: '🚨' }, { color: 'bg-orange-500', icon: '🔧' }],
        gradient: 'from-red-400 to-orange-500',
        bpmnTemplate: bpmnTemplates.incidentManagement,
    },
    {
        id: 'it-2',
        title: 'Service Request Fulfillment',
        description: 'Handle IT service requests from submission to fulfillment with SLA tracking.',
        category: 'IT',
        popular: false,
        icons: [{ color: 'bg-indigo-500', letter: '🎫' }, { color: 'bg-blue-500', icon: '⚡' }],
        gradient: 'from-indigo-400 to-blue-500',
        bpmnTemplate: bpmnTemplates.incidentManagement,
    },
    {
        id: 'it-3',
        title: 'Change Management',
        description: 'Manage IT change requests with approval workflows and rollback procedures.',
        category: 'IT',
        popular: true,
        icons: [{ color: 'bg-purple-500', letter: '🔄' }, { color: 'bg-pink-500', icon: '📦' }],
        gradient: 'from-purple-400 to-pink-500',
        bpmnTemplate: bpmnTemplates.invoiceApproval,
    },
];

// Connector data
export const connectors = [
    {
        id: '1',
        name: 'Power Automate',
        description: 'Leverage microservices within the Powerautomate to automate workflows.',
        icon: '◎',
        iconBg: 'bg-gradient-to-br from-teal-400 to-cyan-500',
        active: true
    },
    {
        id: '2',
        name: 'Google Mail',
        description: "Incorporates APIs and data exchange within Google's suite of productivity tools.",
        icon: 'G',
        iconBg: 'bg-gradient-to-br from-blue-500 via-red-500 to-yellow-500',
        active: true
    },
    {
        id: '3',
        name: 'Microsoft Outlook',
        description: 'Integrate with Microsoft services enabling automated workflows and data sync.',
        icon: '⊞',
        iconBg: 'bg-gradient-to-br from-blue-600 to-blue-400',
        active: true
    },
    {
        id: '4',
        name: 'FTP',
        description: 'Utilizes integration tools with FTP to connect and automate process.',
        icon: 'FTP',
        iconBg: 'bg-gradient-to-br from-purple-500 to-purple-600',
        active: true
    },
    {
        id: '5',
        name: 'Google Drive',
        description: 'List and download files from Google Drive folders, including auto-export of Docs, Sheets, and Slides.',
        icon: '▲',
        iconBg: 'bg-gradient-to-br from-yellow-400 via-green-500 to-blue-500',
        active: true
    }
];
